<div class="md_title-3xl title-2xl color-primary">
  <ng-content></ng-content>
</div>
